wbApp.controller('ContractsDetailCtrl', ['$scope', '$modal', 'contractSvc',
function ($scope, $modal, contractSvc) {

    $scope.model = contractSvc.transformModelForEdit($scope.model);
    
    $scope.modelOrig = angular.copy($scope.model);

    $scope.onDeleteSchedule = function(schedule) {
        const index = $scope.model.contractSchedules.indexOf(schedule);
        if (index > -1) {
            $scope.model.contractSchedules.splice(index, 1);
        }
        if ($scope.model.contractSchedules.length === 0) {
            $scope.onAddSchedule();
        }
    }
    
    $scope.onAddSchedule = function() {
        $scope.model.contractSchedules.push({
            monday: { active: false, startTime: null, endTime: null, food: false },
            tuesday: { active: false, startTime: null, endTime: null, food: false },
            wednesday: { active: false, startTime: null, endTime: null, food: false },
            thursday: { active: false, startTime: null, endTime: null, food: false },
            friday: { active: false, startTime: null, endTime: null, food: false },
            saturday: { active: false, startTime: null, endTime: null, food: false },
            sunday: { active: false, startTime: null, endTime: null, food: false },
        });
    }
    
    $scope.onActiveClick = function(daySchedule, active) {
        if (!active) {
            daySchedule.startTime = null;
            daySchedule.endTime = null;
            daySchedule.food = false;
        }
    }

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        let modelForSave = contractSvc.transformModelForSave(angular.copy(data));
        
        $scope.isSaving = true;

        if (!data.id) {
            contractSvc.insert(modelForSave)
                .$promise.then(success, error);
        } else {
            contractSvc.update(modelForSave)
                .$promise.then(success, error);
        }

        function success(newModel) {
            $scope.onContractSave(newModel);
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };


    $scope.isFormValid = function() {
        return true;
    }
    
    $scope.detailTabs = [{
        title: 'TXT_MAIN',
        template: "activities/contracts/contract-detail-main-tab.html"
    },{
        title: 'TXT_SCHEDULE',
        template: "activities/contracts/contract-detail-schedule-tab.html"
    },{
        title: 'TXT_TEMPLATES',
        template: "activities/contracts/contract-detail-templates-tab.html"
    }];

    $scope.detailTabs.activeTab = 0;
}]);
